import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import BlueDotPoly from '../../images/polygons/blue-dot.svg';
import LightTriPoly from '../../images/polygons/light-tri.svg';

const useStyles = makeStyles(() => ({
  polies: {
    position: 'absolute',
  },
  lightTriPy: {
    top: '-10%',
    right: '5%',
  },
  blueDotPy: {
    left: '-30%',
    top: '-14%',
    zIndex: 0,
  },
}));

function Polygons() {
  const classes = useStyles();
  return (
    <>
      <img
        src={BlueDotPoly}
        className={ClassNames(classes.polies, classes.blueDotPy)}
        alt=""
      />
      <img
        src={LightTriPoly}
        className={ClassNames(classes.polies, classes.lightTriPy)}
        alt=""
      />
    </>
  );
}

export default Polygons;
